import React, { useEffect } from "react"
import useEntityPicker from "../../../../hooks/useEntityPicker"
import { SCHEDULE } from "../../../../library/store/actions/types/calendarTypes"
import PickerSelect from "../select/pickerSelect"

const SchoolCalendarPicker = ({
  value = "",
  onChange,
  groupId,
  hasError = false,
  errorMessage = "Field is required",
  required = true,
  disabled = false,
  emptyListMessage,
  emptyListLink,
}) => {
  const { fetchList, list, dataReceived, isWaitingForOtherFields } =
    useEntityPicker({
      fetchConfig: {
        apiUrl: SCHEDULE.SCHEDULES.LIST,
        params: {
          school_id: groupId,
          offset: 0,
          limit: 100,
        },
      },
      key: "schedules",
      loadOnMount: !!groupId,
    })

  useEffect(() => {
    if (groupId) {
      fetchList()
    }
  }, [groupId])

  return (
    <PickerSelect
      name={"schedule"}
      entityName={"schedule"}
      value={value}
      onChange={onChange}
      required={required}
      hasError={hasError}
      errorMessage={errorMessage}
      disabled={disabled || !dataReceived}
      list={list}
      isWaitingForOtherFields={isWaitingForOtherFields}
      isWaitingForOtherFieldsMessage={"First select school"}
      emptyListMessage={emptyListMessage}
      emptyListLink={emptyListLink}
    />
  )

  // const hasSchedules = dataReceived && !!list.length
  //
  // const field = (
  //   <FormControl error={hasError} fullWidth>
  //     <Select
  //       error={hasError}
  //       id="schedule"
  //       name="schedule"
  //       fullWidth
  //       displayEmpty
  //       disabled={!dataReceived}
  //       value={value}
  //       onChange={onChange}
  //       renderValue={(v) => <SelectValue entityName={'schedule'} value={v} />}
  //     >
  //       <MenuItem disabled value={''}>
  //         Select schedule
  //       </MenuItem>
  //       {list.map((item) => (
  //         <MenuItem value={item} key={item.id}>
  //           {item.name}
  //         </MenuItem>
  //       ))}
  //     </Select>
  //     <ErrorMessage error={hasError} message={errorMessage} />
  //   </FormControl>
  // )

  // return (
  //   <div className="form__fieldset">
  //     <label htmlFor="schedule" className="form__label">
  //       Schedule {required && '*'}
  //     </label>
  //     <div className="form__fieldbox">
  //       <div className="form__input form__input--select">
  //         {/*{hasSchedules ? (*/}
  //         {field}
  //         {/*) : (*/}
  //         {/*  <p className={'error-message'}>*/}
  //         {/*    You don't have schedules. Create one and then come back*/}
  //         {/*    here.*/}
  //         {/*  </p>*/}
  //         {/*)}*/}
  //       </div>
  //     </div>
  //   </div>
  // )
}

export default SchoolCalendarPicker
